var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3021_3460",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3021_3460)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.99209 15.9453C9.82751 15.9453 9.6691 15.9167 9.51688 15.8596C9.36466 15.8024 9.22014 15.7124 9.08334 15.5896L8.09459 14.689C6.57542 13.3418 5.24931 12.0391 4.11626 10.7811C2.9832 9.52303 2.41667 8.19317 2.41667 6.7915C2.41667 5.69192 2.79355 4.77123 3.5473 4.02942C4.30119 3.28748 5.23681 2.9165 6.35417 2.9165C7.00112 2.9165 7.64126 3.06449 8.27459 3.36046C8.90778 3.65643 9.48292 4.15963 10 4.87005C10.5449 4.15963 11.1288 3.65643 11.7517 3.36046C12.3747 3.06449 13.0039 2.9165 13.6392 2.9165C14.7568 2.9165 15.6936 3.28748 16.4496 4.02942C17.2054 4.77123 17.5833 5.69192 17.5833 6.7915C17.5833 8.20928 17.0035 9.55116 15.8438 10.8171C14.684 12.0831 13.3713 13.371 11.9054 14.6809L10.9085 15.5896C10.7719 15.7124 10.6261 15.8024 10.4713 15.8596C10.3163 15.9167 10.1565 15.9453 9.99209 15.9453ZM9.48396 6.03192C9.10258 5.34498 8.64181 4.83456 8.10167 4.50067C7.56167 4.16678 6.97917 3.99984 6.35417 3.99984C5.53875 3.99984 4.85917 4.26373 4.31542 4.7915C3.77181 5.31928 3.50001 5.98866 3.50001 6.79963C3.50001 7.44907 3.70862 8.1213 4.12584 8.8163C4.54306 9.5113 5.06681 10.2089 5.69709 10.9092C6.32737 11.6096 7.01195 12.2899 7.75084 12.95C8.48959 13.6103 9.1832 14.2289 9.83167 14.8059C9.87973 14.8487 9.93584 14.87 10 14.87C10.0642 14.87 10.1203 14.8487 10.1683 14.8059C10.8168 14.2289 11.5104 13.6103 12.2492 12.95C12.9881 12.2899 13.6726 11.6096 14.3029 10.9092C14.9332 10.2089 15.457 9.5113 15.8742 8.8163C16.2914 8.1213 16.5 7.44907 16.5 6.79963C16.5 5.98866 16.2282 5.31928 15.6846 4.7915C15.1408 4.26373 14.4613 3.99984 13.6458 3.99984C13.0208 3.99984 12.4349 4.16678 11.8879 4.50067C11.3408 4.83456 10.8766 5.34498 10.4952 6.03192C10.4524 6.13873 10.3842 6.21539 10.2906 6.26192C10.197 6.30831 10.0998 6.3315 9.99896 6.3315C9.89813 6.3315 9.79778 6.30831 9.69792 6.26192C9.59806 6.21539 9.52674 6.13873 9.48396 6.03192Z",
    fill: "#4B4B4B"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/heart.db9af621dfd2993040b1e2b412d4deee.svg";
export { ForwardRef as ReactComponent };